import { useEffect, useMemo, useState } from 'react';

import type { OrderSummary } from '#domain/Order.ts';

import { getStopsFromOrders, type TourStop } from './TourStop.ts';

export const useHandleTourStops = (isOpen: boolean, orders: OrderSummary[], initialStops?: TourStop[]) => {
    const [isMisplaced, setIsMisplaced] = useState(false);
    const [misplacedStopIds, setMisplacedStopIds] = useState<string[]>([]);
    const [sortedTourStops, setSortedTourStops] = useState<TourStop[]>([]);

    const orderIdsKey = useMemo(() => orders.map(order => order.id).join('|'), [orders]);

    useEffect(() => {
        if (isOpen) {
            setSortedTourStops(initialStops ?? getStopsFromOrders(orders));
        }
    }, [initialStops, isOpen, orderIdsKey]);

    useEffect(() => {
        if (isOpen) {
            const misplacedIds = sortedTourStops.reduce<string[]>((ids, item, index) => {
                if (item.type === 'unload') {
                    const loadIndex = sortedTourStops.findIndex(
                        (el: TourStop) => el.group === item.group && el.type === 'load'
                    );
                    if (loadIndex !== -1 && index < loadIndex) {
                        ids.push(item.id);
                    }
                }
                return ids;
            }, []);
            setMisplacedStopIds(misplacedIds);
            setIsMisplaced(misplacedIds.length > 0);
        }
    }, [isOpen, sortedTourStops]);

    return {
        sortableTourStops: sortedTourStops,
        setSortableTourStops: setSortedTourStops,
        isMisplaced,
        misplacedStopIds,
    };
};
